<script>
    import {onMount} from 'svelte';

    let data;
    export let table = null;

    onMount(async () => {

        const proxyurl = "";
        const url = 'https://plataforma.cvschile.cl/site/documentation-projects';

        try {
            const response = await fetch(proxyurl + url);
            data = await response.json();
        } catch (error) {
            console.log(error);
        }

        let tableCols = [
            {title: "Nombre"},
            {title: "Región"},
            {title: "Comuna"},
            {title: "Ciudad"},
            {title: "Cantidad de viviendas"},
            {title: "Superficie construida"},
        ];

        table = window.$('#dataTable2').DataTable({
            responsive: true,
            data: data,
            columns: tableCols,
            language: {
                "sProcessing": "Procesando...",
                "sLengthMenu": "Mostrar _MENU_ registros",
                "sZeroRecords": "No se encontraron resultados",
                "sEmptyTable": "Ningún dato disponible en esta tabla",
                "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                "sInfoPostFix": "",
                "sSearch": "Buscar:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Cargando...",
                "oPaginate": {
                    "sFirst": "Primero",
                    "sLast": "Último",
                    "sNext": "Siguiente",
                    "sPrevious": "Anterior"
                },
                "oAria": {
                    "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                    "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                },
                "buttons": {
                    "copy": "Copiar",
                    "colvis": "Visibilidad"
                }
            }
        });

    });

</script>

<svelte:options accessors/>

<table id="dataTable2" class="display nowrap" style="width:100%">

</table>
{#if !data}
    <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status" style="height: 100px;width: 100px;">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
{/if}
<style>

    #dataTable2 {
        font-size: 12pt !important;
        font-family: 'DINPro-Regular';
        color: #006937;
    }

    #dataTable2 {
        font-size: 12pt !important;
        font-family: 'DINPro-Regular';
        color: #006937;
    }

</style>
